import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  textColor: {
    color: '#343434',
    fontSize: '13px',
    lineHeight: '18px',
    letterSpacing: '0px',
    fontWeight: '600'
  }
});

const WidgetTitle = ({ children, ...rest }) => {
  const classes = useStyles();
  return (
    <Typography className={classes.textColor} variant="h3" component="h3" {...rest}>
      {children}
    </Typography>
  );
};

WidgetTitle.propTypes = {
  children: PropTypes.node.isRequired
};

export default WidgetTitle;
